<template>
  <div class="vb-accordion" role="tablist">
    <div
      v-for="(item, index) in items"
      :key="item_id(index)"
      class="vb-accordion__item"
    >
      <button
        v-b-toggle="item_id(index)"
        type="button"
        class="vb-accordion__question"
      >
        <span>{{ item.question }}</span>

        <vb-icon
          class="vb-accordion__chevron"
          name="angle_small_down"
          :color="sass('gray-900')"
          :size="26"
        />
      </button>

      <b-collapse
        :id="item_id(index)"
        :accordion="group"
        role="tabpanel"
      >
        <div class="vb-accordion__answer">
          <slot name="answer" :item="item" :index="index">
            <p class="vb-accordion__answer-text">{{ item.answer }}</p>
          </slot>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'vb-accordion',

    props: {
      items: {
        type: Array,
        default: () => [],
      },
      accordion_id: {
        type: String,
        default: '',
      },
    },

    computed: {
      group() {
        return this.accordion_id || `vb_accordion_${this._uid}`;
      },
    },

    methods: {
      item_id(index) {
        return `${this.group}_${index}`;
      },
    },
  };
</script>

<style lang="scss" scoped>

  .vb-accordion {

    & > * + * {
      margin-top: $grid-gutter-20 / 2;
    }

    &__item {
      background-color: $white;
      border-radius: $border-radius-lg * 2;
    }

    &__question {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: ($grid-gutter-width / 2) $grid-gutter-20;
      font-size: $font-size-base;
      color: $gray-900;
      text-align: left;
      background-color: transparent;
      border: 0;

      &.not-collapsed .vb-accordion__chevron {
        transform: rotate(180deg);
      }
    }

    &__chevron {
      flex-shrink: 0;
      margin-left: $grid-gutter-width / 2;
      transition: transform .2s ease;
    }

    &__answer {
      padding: 0 $grid-gutter-20 ($grid-gutter-width / 2);
      font-size: $font-size-md;
      color: $gray-700;
    }

    &__answer-text {
      margin: 0;
    }
  }
</style>
